export class OperationalPriceListWeightThresholdModel {
  id: string;
  limiting_threshold: string;
  base_amount: string;
}
